type FolderData = {
  id: string;
  name: string;
  parentId?: string | null;
};

export function buildFoldersMap(
  folders: FolderData[],
): Map<string, FolderData> {
  const map = new Map<string, FolderData>();
  for (const folder of folders) {
    map.set(folder.id, folder);
  }
  return map;
}

export function getGroupDisplayName(
  group: { name: string; folderId?: string | null },
  foldersMap: Map<string, FolderData>,
): string {
  if (!group.folderId) {
    return group.name;
  }

  const segments: string[] = [];
  const visited = new Set<string>();
  let currentId: string | null | undefined = group.folderId;

  while (currentId && foldersMap.has(currentId) && !visited.has(currentId)) {
    visited.add(currentId);
    const folder: FolderData = foldersMap.get(currentId)!;
    segments.unshift(folder.name);
    currentId = folder.parentId;
  }

  if (segments.length === 0) {
    return group.name;
  }

  return `${segments.join('/')}/${group.name}`;
}
